var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpinner = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid",
  width: 104,
  height: 104,
  style: {
    shapeRendering: "auto",
    display: "block",
    background: "transparent"
  },
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(0 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.9166666666666666s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.8333333333333334s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(60 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.75s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(90 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.6666666666666666s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(120 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.5833333333333334s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(150 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.5s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.4166666666666667s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(210 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.3333333333333333s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(240 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.25s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(270 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.16666666666666666s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(300 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.08333333333333333s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(330 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 3,
  ry: 6,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "0s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", null))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpinner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "4b6212852c98d23546e3ea5dd5efe546.svg";